<template>
  <div class='simDashboard'>    
    <div class='simDashboardContents row'>
      <div class='curriculumDashContents col-3'>
        <div id='startFinishGraph' class='dashboardWidgetContent'>
          <h4>Completed/Started/Not Started</h4>
          <div class="dashbox" v-if="sfdata!==null&&sfoptions!==null">
            <dash-doughnut :data="sfdata" :options="sfoptions"></dash-doughnut>
          </div>
          <div v-if="sfdata===null||sfoptions===null">
            Loading...
          </div>
        </div>
       
      </div>
      <div class='lessonDashContents col-9' style='border-left:1px solid rgb(110,110,107)'>
        <h4 style='margin-top:3px;'>Lesson Data</h4>
        <div class="dashbox" v-if="dbdata!==null&&dboptions!==null">
          <dash-bar :data="dbdata" :options="dboptions"></dash-bar>
        </div>
        <div v-if="dbdata===null||dboptions===null">
          Loading...
        </div>
      </div>
    </div>
 </div>
</template>

<script>
   import DashDoughnut from '../mixins/DashDoughnut.js';
   import DashBar from '../mixins/DashBar.js';
 

   export default {
    name: "TrainingPlanDash",
    components:{DashDoughnut,DashBar},
    data() {
      return {
        data:null,
        dbdata:null,
        dboptions:null,
        scdata:null,
        sfdata:null,
        sfoptions:null,
        presets: {
          red: '#215176',
          orange: 'rgb(255, 159, 64)',
          yellow: 'rgb(255, 205, 86)',
          green: '#357d70',
          blue: '#9bc4e3',
          purple: 'rgb(153, 102, 255)',
          grey: 'rgb(201, 203, 207)'
        }
      }
    },
    methods:{

     curriculumStartedGraph() {
  
       if (this.data.TrainingPlanUsers.length>0) {

         var completed = this.data.TrainingPlanUsers.filter(p=>p.Status==="Completed").length;
         var started = this.data.TrainingPlanUsers.filter(p=>p.Status==="Started").length;
         var notstarted = this.data.TrainingPlanUsers.filter(p=>p.Status==="Not Started").length;
        
         this.sfdata= {
           datasets: [{
             data: [
                 completed,started,notstarted
             ],
             backgroundColor: [
                 this.presets.green,
                 this.presets.blue,
                 this.presets.red
             ],
             datalabels: {
               listeners: {
                 click: function(context) {
                   console.log('label ' + context.dataIndex + ' has been clicked!');
                 }
               }
             }
           }],
           labels: [
               'Completed',
               'Started',
               'Not Started',
           ]
         };

         this.sfoptions= {
           maintainAspectRatio: false,
           legend: {
             position: 'top',
           },
           animation: {
             animateScale: true,
             animateRotate: true
           },
           events:['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
           plugins: {
             datalabels: {
               display: true,
               align: 'bottom',
               backgroundColor: '#ccc',
               borderRadius: 3,
               font: {
                 size: 18,
               }
             }
           }
         };
       }
        
      },
      lessonBarChart() {
        if (this.data.LessonUsers.length > 0) {

          var lbls = [];
          var completions = [];
          var nocompletions = [];
          var nostarts = [];
          var starts = [];
          var nostartsbkgnd = [];
          var startsbkgnd = [];
          var nocompletionsbkgnd = [];
          var completionsbkgnd = [];

          for (var x = 0; x < this.data.LessonUsers.length; x++) {
            lbls.push(this.data.LessonUsers[x].Name);

            nostarts.push(this.data.LessonUsers[x].LessonUsers.filter(p=>p.Status==="Not Started").length);
            starts.push(this.data.LessonUsers[x].LessonUsers.filter(p=>p.Status==="Started").length);         
            completions.push(this.data.LessonUsers[x].LessonUsers.filter(p=>p.Status==="Completed").length);

            nostartsbkgnd.push(this.presets.red);
            startsbkgnd.push(this.presets.blue);
            completionsbkgnd.push(this.presets.green);
          }
        
          this.dbdata= {
            datasets: [{
              label: "Not Started",
              data: nostarts,
              backgroundColor: nostartsbkgnd,            
              datalabels: {
                listeners: {
                      click: function(context) {
                        console.log('label b' + context.dataIndex + ' has been clicked!');
                      }
                 }
              }
            }, {
              label: "Started",
              data: starts,
              backgroundColor: startsbkgnd,
              datalabels: {
                listeners: {
                  click: function(context) {
                    console.log('label b' + context.dataIndex + ' has been clicked!');
                  }
                }
              }
            }, {
              label: "Completed",
              data: completions,
              backgroundColor: completionsbkgnd,
              datalabels: {
                listeners: {
                  click: function(context) {
                    console.log('label b' + context.dataIndex + ' has been clicked!');
                  }
                }
              }
            }],
            labels: lbls
          };

          this.dboptions= {
            maintainAspectRatio: false,
            events:['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
            plugins: {
              datalabels: {
                display: true,
                align: 'bottom',
                backgroundColor: '#ccc',
                borderRadius: 3,
                font: {
                  size: 18,
                }
              }
            },
            legend: {
              position: 'top',
            },
            scales: {
              xAxes: [{
                stacked:true
              }],
              yAxes: [{
                stacked:true
              }]
            },
            animation: {
              animateScale: true,
              animateRotate: true
            }
          };


        }
       
      },
      setData(_data) {
        this.data=_data;
        this.curriculumStartedGraph();
        this.lessonBarChart();
      }
    }
   }
</script>
